import Model from "./base/model";

class RequestFiles extends Model {
  resourceName() {
    return "request_files";
  }

  fields() {
    return {
      file: "",
      path: "",
      name: "",
      number: "",
      serie: "",
      key: "",
      value: "",
      weight: "",
      volume: "",
      volume_type: "",
      pdf: "",
      pdf_file: "",
      emission_date: "",
      created_at: "",
      requests: {jsonApi: "hasMany", type: "request"},
      type: "",
    };
  }

  deleteFile(id) {
    return this.request(
      `request_files/files/${id}`,
      "DELETE"
    );
  }

  deleteFilePdf(id) {
    return this.request(
      `request_files/files_pdf/${id}`,
      "DELETE"
    );
  }

}

export default new RequestFiles();
